import React, { useState, useContext, useEffect } from "react";
import "./UserMessageGridLayout.css"; // Import CSS styles
import UMGridLeftLayout from "./Layout/UMGridLeftLayout"
import UMGridCentreLayout from "./Layout/UMgridCentreLayout"
import GridLeftLayout from "../../AccountPage/Layout/UserAccountGridLeft"
import { ThemeContext } from "../../../../context/ThemeContext";
import "../Styles/uac-common-styles.css"

const UserMessagePageGrid = ({pageId}) => {
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
        import(`./Styles/themes/${theme}/themes.css`).then(() => {
          console.log(`Loaded ${theme} styles for UserProfile`);
        }).catch(() => {
          console.error(`Theme CSS not found for ${theme}`);
        });
      }, [theme]);

  return (
    <div className="uac-page-grid">
      {/* Left Sidebar */}
      <div className="uac-left-sidebar-container">
        <UMGridLeftLayout recipientId={pageId}/>
      </div>

      {/* Middle Container */}
      <div className="uac-popover-middle-container" style={{width: 700}}>
        <UMGridCentreLayout />
      </div>        
    </div>
  );
};

export default UserMessagePageGrid;